export const BrazilStates = [
    { uf: 'AC', name: 'Acre', timeZone: -5 },
    { uf: 'AL', name: 'Alagoas', timeZone: -3 },
    { uf: 'AM', name: 'Amazonas', timeZone: -4 },
    { uf: 'AP', name: 'Amapá', timeZone: -3 },
    { uf: 'BA', name: 'Bahia', timeZone: -3 },
    { uf: 'CE', name: 'Ceará', timeZone: -3 },
    { uf: 'DF', name: 'Distrito Federal', timeZone: -3 },
    { uf: 'ES', name: 'Espírito Santo', timeZone: -3 },
    { uf: 'GO', name: 'Goiás', timeZone: -3 },
    { uf: 'MA', name: 'Maranhão', timeZone: -3 },
    { uf: 'MG', name: 'Minas Gerais', timeZone: -3 },
    { uf: 'MS', name: 'Mato Grosso do Sul', timeZone: -4 },
    { uf: 'MT', name: 'Mato Grosso', timeZone: -4 },
    { uf: 'PA', name: 'Pará', timeZone: -3 },
    { uf: 'PB', name: 'Paraíba', timeZone: -3 },
    { uf: 'PE', name: 'Pernambuco', timeZone: -3 },
    { uf: 'PI', name: 'Piauí', timeZone: -3 },
    { uf: 'PR', name: 'Paraná', timeZone: -3 },
    { uf: 'RJ', name: 'Rio de Janeiro', timeZone: -3 },
    { uf: 'RN', name: 'Rio Grande do Norte', timeZone: -3 },
    { uf: 'RO', name: 'Rondônia', timeZone: -4 },
    { uf: 'RR', name: 'Roraima', timeZone: -4 },
    { uf: 'RS', name: 'Rio Grande do Sul', timeZone: -3 },
    { uf: 'SC', name: 'Santa Catarina', timeZone: -3 },
    { uf: 'SP', name: 'São Paulo', timeZone: -3 },
    { uf: 'SE', name: 'Sergipe', timeZone: -3 },
    { uf: 'TO', name: 'Tocantins', timeZone: -3 },
]
export const getStateFullName = uf => BrazilStates.find(st => st.uf === uf).name

export const CnpjMask = [
    /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/,
    /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,
]
export const PlateMask = [
    /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, '-', /\d/, /[A-Za-z0-9]/, /\d/, /\d/,
]
export const CpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
export const CepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
export const CellPhoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
export const PhoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
export const ExpirationDateMask = [/[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/]
export const requiredMessage = 'Esse campo é obrigatório.'
